import React, { useEffect, useState } from "react";
import { PlatformBase, PlatformDialog } from "@platform/style";

export const LoanFilterDialog = () => {
  const [open, setOpen] = useState(false);
  const [loanIdentifier, setLoanIdentifier] = useState<string | null>(null);

  useEffect(() => {
    const filteredLoanEventHandler = (event: Event) => {
      const customEvent = event as CustomEvent<string>;
      setLoanIdentifier(customEvent.detail);
      setOpen(true);
    };

    window.addEventListener("core-to-core-loan-filtered-event", filteredLoanEventHandler);

    return () => {
      window.removeEventListener("core-to-core-loan-filtered-event", filteredLoanEventHandler);
    };
  }, []);

  return (
    <PlatformBase>
      <PlatformDialog
        open={open}
        title={"Don't look at this loan."}
        closeLabel={"Ok"}
        onClose={() => setOpen(false)}
      >
        <p>{`Unfortunately, you are not authorized to access loan ${loanIdentifier}.`}</p>
      </PlatformDialog>
    </PlatformBase>
  );
};
